import React, { FC } from 'react';
import creditMemoExample from '../../../assets/creditMemoExample.png';
import viewReturnOrderNavigation from '../../../assets/viewReturnOrderNavigation.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpAlert, HelpBody, HelpImage, HelpStep, HelpTitle } from './HelpElements';

const ViewingReturnOrderHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('viewingReturnOrderHelp');

    return (
        <>
            <HelpTitle>{t('viewingReturnOrderHelp_Title')}</HelpTitle>
            <HelpBody>{t('viewingReturnOrderHelp_purpose')}</HelpBody>
            <HelpStep step={1}>{t('viewingReturnOrderHelp_navigateToViewReturnOrder')}</HelpStep>
            <HelpImage src={viewReturnOrderNavigation} />
            <HelpStep step={2}>{t('viewingReturnOrderHelp_rmaStatus')}</HelpStep>
            <HelpStep step={3}>{t('viewingReturnOrderHelp_printEmail')}</HelpStep>
            <HelpImage src={creditMemoExample} />
            <HelpAlert type={'warning'}>{t('viewingReturnOrderHelp_usedAsAuthorization')}</HelpAlert>
        </>
    );
};

export { ViewingReturnOrderHelp };
